module.exports = __webpack_public_path__ + "static/media/download-solid.892d95f5.svg";